const addMaskToDocument = (document) => {
  const cleanDocument = document.replace(/\D/g, '');

  return cleanDocument.length === 11 ?
    cleanDocument.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') :
    cleanDocument.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export default addMaskToDocument;
